import axios from 'axios'
import * as React from 'react'
import { csrfToken } from 'helpers'

const axiosInstance = axios.create({
  headers: {
    'Content-Type': 'application/json',
    'x-csrf-token': csrfToken
  }
})

export const useTogglePause = (user_id: string, id: string): UseTogglePause => {
  const listingPauseUrl = `/api/v1/users/${user_id}/listings/${id}/pause`
  const userPauseUrl = `/api/v1/users/${user_id}/pause`

  const [apiState, setApiState] = React.useState<{
    error: boolean
    isLoading: boolean
  }>({
    error: false,
    isLoading: false
  })

  const togglePause = async ({
    userAction,
    pause,
    reason: pause_reason,
    additionalNote: additional_note
  }: TogglePauseProps) => {
    setApiState({ error: false, isLoading: true })

    try {
      const url = userAction ? userPauseUrl : listingPauseUrl
      if (pause) {
        await axiosInstance.put(url, {
          pause_reason,
          additional_note,
          deactivation_reason: 'admin_action'
        })
      } else {
        await axiosInstance.delete(url, {
          data: {
            deactivation_reason: 'admin_action'
          }
        })
      }
    } catch (error) {
      setApiState({ error: true, isLoading: false })

      throw error
    } finally {
      setApiState((prevApiState) => ({ ...prevApiState, isLoading: false }))
    }
  }

  return {
    togglePause,
    error: apiState.error,
    isLoading: apiState.isLoading
  }
}

interface TogglePauseProps {
  userAction?: boolean
  pause: boolean
  reason?: string
  additionalNote?: string
}

interface UseTogglePause {
  togglePause: (info: TogglePauseProps) => Promise<void>
  error: boolean
  isLoading: boolean
}
